import React, { useState } from 'react';
import { Form, Select, Button, Modal, Input } from 'antd';
import FloatingLabel from '../../../components/FloatingLabel/FloatingLabel';
import { CloseIcon } from '../../../assets/icons';
import { dateFormulationForModal } from '../../../utils/getDateForModal';
import './Transaction.scss';
import { getBankLogo } from '../../../utils/getBankLogo';

const ScheduledTransactionDetailsModal = (props) => {
  const { scheduledOpen, setScheduledOpen, modalTransactionData, handlecancelTransfer, loading } = props;
  const { initiatedOn, amount, receiverSource, senderSource, transactionId } = modalTransactionData;
  //set value and logo for receiver and sender
  const transferFrom = senderSource.brandName;
  const transferTo = receiverSource.brandName;
  const SenderLogo = getBankLogo(transferFrom);
  const ReceiverLogo = getBankLogo(transferTo);
  const [arrowUpFrom, setArrowUpFrom] = useState(false);
  const [arrowUpTo, setArrowUpTo] = useState(false);
  return (
    <Modal open={scheduledOpen} width={560} footer={false} closeIcon={<CloseIcon />} onCancel={() => setScheduledOpen(false)} centered>
      <h4 className='text-center'>Transfer details</h4>
      <p className='mb-24'>
        Transfers to and from your Realbricks account will take 2 - 5 business days to complete. Exact timing depends on your bank.
      </p>
      <p className='fw-600 mb-0'>Confirmation code:</p>
      <p>{transactionId}</p>
      <p className='fw-600 mb-0'>Transfer initiated on:</p>
      <p>{dateFormulationForModal(initiatedOn, true)} (EST)</p>
      <p className='fw-600 mb-0'>Status:</p>
      <p className='mb-24'>Scheduled</p>
      <Form className='transfer-form scheduled'>
        <FloatingLabel label='Transfer from' inputId='transferFrom' inputValue={transferFrom}>
          <>
            <div id='from-anchor' />
            <Form.Item name='transferFrom'>
              <Select
                id='transferFrom'
                defaultValue={transferFrom}
                getPopupContainer={() => document.getElementById('from-anchor')}
                onDropdownVisibleChange={() => setArrowUpFrom(!arrowUpFrom)}
                suffixIcon={<></>}
                disabled
              >
                <Select.Option value={transferFrom}>
                  {SenderLogo} {senderSource.brandName} {senderSource.lastFourDigit && `***${senderSource.lastFourDigit}`}
                </Select.Option>
              </Select>
            </Form.Item>
          </>
        </FloatingLabel>
        <FloatingLabel label='Transfer to' inputId='transferTo' inputValue={transferTo}>
          <>
            <div id='to-anchor' />
            <Form.Item name='transferTo'>
              <Select
                id='transferTo'
                defaultValue={transferTo}
                value={transferTo}
                getPopupContainer={() => document.getElementById('to-anchor')}
                onDropdownVisibleChange={() => setArrowUpTo(!arrowUpTo)}
                suffixIcon={<></>}
                disabled
              >
                <Select.Option value={transferTo}>
                  {ReceiverLogo}
                  {receiverSource.brandName} {receiverSource.lastFourDigit && `***${receiverSource.lastFourDigit}`}
                </Select.Option>
              </Select>
            </Form.Item>
          </>
        </FloatingLabel>
        <FloatingLabel label='Enter amount' shortLabel='Amount' inputId='amount' inputValue={amount}>
          <Form.Item>
            <Input id='amount' placeholder='Enter amount' value={'$' + amount} disabled />
          </Form.Item>
        </FloatingLabel>
        <p>To make changes to this transfer, please cancel and reschedule.</p>
        <Button loading={loading} onClick={() => handlecancelTransfer()} className='w-100' type='primary' danger>
          Cancel transfer
        </Button>
      </Form>
    </Modal>
  );
};
export default ScheduledTransactionDetailsModal;
